import { inject, Injectable } from "@angular/core";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { ConfigurationBackend } from "src/app/backend/api/configuration.backend";
import { lastValueFrom } from "rxjs";
import { ConfigurationService } from "src/app/services/configuration.service";

@Injectable()
export class ProvideOrganizationConfigurationGuard {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly configurationBackend = inject(ConfigurationBackend);

  async canActivate(): Promise<boolean> {
    const configuration = await lastValueFrom(
      this.configurationBackend.loadOrganization()
    );

    this.bootstrapService.setCurrentOrganizationConfiguration(configuration);

    return true;
  }
}
